import { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FiRefreshCw } from "react-icons/fi";
import { FiMinusCircle } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa6";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";

// const GlobalTestDetail = () => {
//   const { data } = useMoreStockContext();
//   const { type } = useParams();
//   const navigate = useNavigate();

//   // 🔑 DEFAULT: % Change High → Low
//   const [changeFilter, setChangeFilter] = useState("high");
//   const [volumeFilter, setVolumeFilter] = useState("all");

//   /* ---------------- MERGE ALL GLOBAL DATA ---------------- */
//   const globalRawData = data;

//   /* ---------------- NORMALIZE DATA ---------------- */
//   const normalizedData = globalRawData?.map((item) => ({
//     ticker_id: item.symbol,
//     company: item.symbol,

//     price: item.regularMarketPrice,
//     open: item.regularMarketOpen,
//     close: item.regularMarketPreviousClose,
//     low: item.regularMarketDayLow,
//     high: item.regularMarketDayHigh,

//     volume: item.regularMarketVolume ?? 0,
//     percent_change: item.regularMarketChangePercent ?? 0,
//     currency: item.financialCurrency,
//   }));

//   /* ---------------- SORT LOGIC (CORRECT PRECEDENCE) ---------------- */
//   const sortedData = [...normalizedData].sort((a, b) => {
//     // % CHANGE SORT
//     if (changeFilter === "high") return b.percent_change - a.percent_change;

//     if (changeFilter === "low") return a.percent_change - b.percent_change;

//     // VOLUME SORT (ONLY WHEN % CHANGE IS OFF)
//     if (volumeFilter === "high") return b.volume - a.volume;
//     if (volumeFilter === "low") return a.volume - b.volume;

//     return 0;
//   });

//   const formatVolume = (volume) => {
//     if (!Number.isFinite(volume)) return "-";
//     return volume.toLocaleString("en-US");
//   };
//   console.log("Sorted data", sortedData);

//   return (
//     <>
//       <div
//         className="stocktest-dropdown"
//         style={{ display: "flex", gap: "2rem" }}
//       >
//         <div
//           className=" select-option dropdown"
//           style={{ display: "flex", justifyContent: "center", gap: "3rem" }}
//         >
//           <select
//             value={changeFilter}
//             onChange={(e) => {
//               setChangeFilter(e.target.value);
//               setVolumeFilter("all");
//             }}
//           >
//             <option value="high">% Change High → Low</option>
//             <option value="low">% Change Low → High</option>
//           </select>
//         </div>
//         <div className="select-option dropdown">
//           <select
//             value={volumeFilter}
//             onChange={(e) => {
//               setVolumeFilter(e.target.value);
//               setChangeFilter("all");
//             }}
//           >
//             <option value="all">Volume</option>
//             <option value="high">Volume High → Low</option>
//             <option value="low">Volume Low → High</option>
//           </select>
//         </div>
//       </div>

//       <div className="stock-table-container">
//         <h1 className="stocktest-h1">
//           {" "}
//           {type === "active"
//             ? "Most Active"
//             : type === "gainers"
//               ? "Top Gainers"
//               : "Top Losers"}
//         </h1>

//         <table className="stock-table">
//           <thead>
//             <tr>
//               <th>Symbol</th>
//               <th>Price</th>
//               <th>% Change</th>
//               <th>Low</th>
//               <th>High</th>
//               <th>Volume</th>
//             </tr>
//           </thead>

//           <tbody>
//             {sortedData?.map((stock) => (
//               <tr
//                 key={stock.ticker_id}
//                 className="stock-row"
//                 onClick={() => navigate(`/globalInfo/${stock.company}`)}
//               >
//                 <td>{stock.company}</td>
//                 <td>
//                   {stock.price} {stock?.currency}
//                 </td>

//                 <td
//                   style={{
//                     color: stock.percent_change >= 0 ? "#249966" : "#f87171",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {stock.percent_change.toFixed(2)}%
//                 </td>

//                 <td>
//                   {stock.low} {stock?.currency}
//                 </td>
//                 <td>
//                   {stock.high} {stock?.currency}
//                 </td>
//                 <td>{formatVolume(stock.volume)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };
const GlobalTestDetail = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  const { getScreenerData, screener } = useMarketIndicators();

  const [changeFilter, setChangeFilter] = useState("high");
  const [volumeFilter, setVolumeFilter] = useState("all");
  const [alphaFilter, setAlphaFilter] = useState("all");
  const [companySort, setCompanySort] = useState("none");
  const [percentSort, setPercentSort] = useState("none");

  // Fetch screener data on mount (same as TestOHLC)
  useEffect(() => {
    if (screener && Object.keys(screener).length > 0) return;
    getScreenerData();
  }, []);
  console.log("Screener data on detail page", screener);

  const normalizeGlobalStock = (stock) => ({
    symbol: stock?.symbol,
    company:
      stock?.shortName ||
      stock?.longName ||
      stock?.displayName ||
      stock?.symbol,
    lastPrice: stock?.regularMarketPrice ?? 0,
    open: stock?.regularMarketOpen ?? 0,
    previousClose: stock?.regularMarketPreviousClose ?? 0,
    dayLow: stock?.regularMarketDayLow ?? 0,
    dayHigh: stock?.regularMarketDayHigh ?? 0,
    pChange: stock?.regularMarketChangePercent ?? 0,
    totalTradedVolume: stock?.regularMarketVolume ?? 0,
    currency: stock?.financialCurrency || stock?.currency || "USD",
    isGlobal: true,
  });

  // Build the full dataset from screener
  const globalAllStocks = useMemo(() => {
    const gainers = (screener?.data?.day_gainers || []).map(
      normalizeGlobalStock,
    );
    console.log("Gainers", gainers);
    const losers = (screener?.data?.day_losers || []).map(normalizeGlobalStock);
    const actives = (screener?.data?.most_actives || []).map(
      normalizeGlobalStock,
    );
    return [...gainers, ...losers, ...actives];
  }, [screener]);
  console.log("All global stocks data", globalAllStocks);

  // Pick the right subset based on route type, or show all
  const baseData = useMemo(() => {
    if (type === "Gainers" || type === "gainers") {
      return (screener?.data.day_gainers || []).map(normalizeGlobalStock);
    }
    if (type === "Losers" || type === "losers") {
      return (screener?.day_losers || []).map(normalizeGlobalStock);
    }
    if (type === "Most Active" || type === "active") {
      return (screener?.most_actives || []).map(normalizeGlobalStock);
    }
    return globalAllStocks;
  }, [screener, type, globalAllStocks]);

  // Advances / Declines / Unchanged
  const { advances, declines, unChanged } = useMemo(() => {
    let adv = 0;
    let dec = 0;
    let unc = 0;

    baseData.forEach((item) => {
      if (item?.pChange > 0) adv++;
      else if (item?.pChange < 0) dec++;
      else unc++;
    });

    return { advances: adv, declines: dec, unChanged: unc };
  }, [baseData]);

  // Sorting
  const sortedData = useMemo(() => {
    return [...baseData].sort((a, b) => {
      if (companySort === "asc")
        return (a.symbol || "").localeCompare(b.symbol || "");
      if (companySort === "desc")
        return (b.symbol || "").localeCompare(a.symbol || "");

      if (percentSort === "high" || changeFilter === "high")
        return b.pChange - a.pChange;
      if (percentSort === "low" || changeFilter === "low")
        return a.pChange - b.pChange;

      if (volumeFilter === "high")
        return b.totalTradedVolume - a.totalTradedVolume;
      if (volumeFilter === "low")
        return a.totalTradedVolume - b.totalTradedVolume;

      if (alphaFilter === "az")
        return (a.symbol || "").localeCompare(b.symbol || "");
      if (alphaFilter === "za")
        return (b.symbol || "").localeCompare(a.symbol || "");

      return 0;
    });
  }, [
    baseData,
    companySort,
    percentSort,
    changeFilter,
    volumeFilter,
    alphaFilter,
  ]);

  const formatVolume = (volume) => {
    if (!Number.isFinite(volume)) return "-";
    return volume.toLocaleString("en-US");
  };

  const formatTimestamp = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();
    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    return `${day}-${month}-${year} | ${time}`;
  };

  const [lastUpdate, setLastUpdate] = useState(formatTimestamp());

  const handleRefresh = async () => {
    try {
      await getScreenerData();
      setLastUpdate(formatTimestamp());
    } catch (err) {
      console.error("Refresh failed", err);
    }
  };

  // Sort helpers (matching StockTestDetail)
  const sortCompanyAsc = () => {
    setCompanySort("asc");
    setPercentSort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
  };
  const sortCompanyDesc = () => {
    setCompanySort("desc");
    setPercentSort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
  };
  const sortPercentHigh = () => {
    setPercentSort("high");
    setCompanySort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
  };
  const sortPercentLow = () => {
    setPercentSort("low");
    setCompanySort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
  };
  const sortVolumeHigh = () => {
    setVolumeFilter("high");
    setCompanySort("none");
    setPercentSort("none");
    setChangeFilter("all");
    setAlphaFilter("all");
  };
  const sortVolumeLow = () => {
    setVolumeFilter("low");
    setCompanySort("none");
    setPercentSort("none");
    setChangeFilter("all");
    setAlphaFilter("all");
  };

  const pageTitle =
    type === "active" || type === "Most Active"
      ? "Most Active"
      : type === "gainers" || type === "Gainers"
        ? "Top Gainers"
        : type === "losers" || type === "Losers"
          ? "Top Losers"
          : "Global Markets";

  if (!screener || Object.keys(screener).length === 0) {
    return (
      <p
        style={{
          fontSize: "1rem",
          fontWeight: "700",
          display: "flex",
          gap: "1rem",
        }}
      >
        Fetching Global data..{" "}
        <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
          <FaSpinner />
        </span>
      </p>
    );
  }

  return (
    <>
      {/* <div className="trend-export">
        <div className="index-row">
          <div className="card-head test-head-dash">
            <h2>{pageTitle} — Global</h2>
          </div>
        </div>
      </div> */}

      <div className="test-card-head">
        <div className="card-head test-head-dash">
          <h2>{pageTitle}</h2>
        </div>

        <div className="test-card-stats">
          <p style={{ color: "#16a34a" }}>
            <IoMdTrendingUp />
            Advances - {advances}
          </p>
          <p style={{ color: "#dc2626" }}>
            <IoMdTrendingDown />
            Declines - {declines}
          </p>
          <p style={{ color: "#6b7280" }}>
            <FiMinusCircle />
            Unchanged - {unChanged}
          </p>
        </div>

        <div
          className="last-updated-head"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "13px",
            color: "#6b7280",
          }}
        >
          <span>As on {lastUpdate}</span>
          <FiRefreshCw
            size={16}
            onClick={handleRefresh}
            style={{ cursor: "pointer", transition: "0.2s" }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#6b7280")}
          />
        </div>
      </div>

      <div className="stock-table-container">
        <table className="stock-table">
          <thead>
            <tr>
              <th>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  Company
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortCompanyAsc} />
                    <FaChevronDown size={10} onClick={sortCompanyDesc} />
                  </div>
                </div>
              </th>
              <th>Price</th>
              <th>Open</th>
              <th>Prev Close</th>
              <th>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  % Change
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortPercentHigh} />
                    <FaChevronDown size={10} onClick={sortPercentLow} />
                  </div>
                </div>
              </th>
              <th>Low</th>
              <th>High</th>
              <th>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  Volume
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortVolumeHigh} />
                    <FaChevronDown size={10} onClick={sortVolumeLow} />
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData?.map((stock) => {
              const percentChange = stock.pChange ?? 0;
              return (
                <tr
                  key={stock.symbol}
                  className="stock-row"
                  onClick={() => navigate(`/globalInfo/${stock.symbol}`)}
                >
                  <td>
                    <div className="trendpro-company">
                      <small>{stock.company}</small>
                      <strong>{stock.symbol}</strong>
                    </div>
                  </td>
                  <td>
                    {stock.lastPrice} {stock.currency}
                  </td>
                  <td>
                    {stock.open} {stock.currency}
                  </td>
                  <td>
                    {stock.previousClose} {stock.currency}
                  </td>
                  <td
                    style={{
                      color:
                        percentChange > 0
                          ? "#249966"
                          : percentChange < 0
                            ? "#f87171"
                            : "#64748b",
                      fontWeight: "bold",
                    }}
                  >
                    {percentChange > 0 ? "+" : ""}
                    {percentChange.toFixed(2)}%
                  </td>
                  <td>
                    {stock.dayLow} {stock.currency}
                  </td>
                  <td>
                    {stock.dayHigh} {stock.currency}
                  </td>
                  <td>{formatVolume(stock.totalTradedVolume)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Mobile cards — same structure as StockTestDetail */}
        <section className="trendpro-mobile-list">
          {sortedData?.map((stock) => {
            const percentChange = stock.pChange ?? 0;
            const isPositive = percentChange >= 0;
            const color = isPositive ? "#249966" : "#f87171";
            const change = stock.lastPrice - stock.previousClose;

            return (
              <div
                key={stock.symbol}
                className="trendpro-mobile-card"
                onClick={() => navigate(`/globalInfo/${stock.symbol}`)}
              >
                <div className="trendpro-mobile-head">
                  <div className="mobile-head-trendpro">
                    <span className="trendpro-company">{stock.company}</span>
                    <h3>{stock.symbol}</h3>
                  </div>

                  <div className="trendpro-mobile-price">
                    <div
                      className="trendpro-mobile-subprice"
                      style={{
                        background: isPositive ? "#ecfdf5" : "#fef2f2",
                        border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                      }}
                    >
                      <span
                        className={`trendpro-mobile-ltp ${isPositive ? "index-chip-green" : "index-chip-red"}`}
                      >
                        {stock.lastPrice} {stock.currency}
                      </span>

                      <div
                        className={`trendpro-mobile-change ${isPositive ? "positive" : "negative"}`}
                      >
                        {isPositive ? <IoMdTrendingUp /> : <IoMdTrendingDown />}
                        <span
                          className={
                            isPositive ? "index-chip-green" : "index-chip-red"
                          }
                        >
                          {change > 0
                            ? `+${change.toFixed(2)}`
                            : change.toFixed(2)}
                        </span>
                        <span
                          className={
                            isPositive ? "index-chip-green" : "index-chip-red"
                          }
                        >
                          (
                          {percentChange > 0
                            ? `+${percentChange.toFixed(2)}`
                            : percentChange.toFixed(2)}
                          %)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="trendpro-mobile-grid">
                  <div>
                    <span>Open</span>
                    <b>
                      {stock.open} {stock.currency}
                    </b>
                  </div>
                  <div>
                    <span>High</span>
                    <b>
                      {stock.dayHigh} {stock.currency}
                    </b>
                  </div>
                  <div>
                    <span>Low</span>
                    <b>
                      {stock.dayLow} {stock.currency}
                    </b>
                  </div>
                  <div>
                    <span>Prev Close</span>
                    <b>
                      {stock.previousClose} {stock.currency}
                    </b>
                  </div>
                  <div>
                    <span>Volume</span>
                    <b>{formatVolume(stock.totalTradedVolume)}</b>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </>
  );
};

export default GlobalTestDetail;
